import {
  defaultBackgroundSetting,
  defaultBorderSetting,
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultIconSetting,
  defaultComplexFontSetting,
  defaultSimpleFontSetting,
  defaultSizeSetting
} from "@/materials/navMenu/render/customSubMenus/setting/defaultSetting"
export const props = [
  {
    name: "enableBackToTop",
    desc: '开启"返回顶部"',
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "showBackText",
    desc: "显示文字",
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "backInnerText",
    desc: "内容",
    type: "inputSet",
    defaultValue: ''
  },
  {
    name: "backInnerTips",
    desc: "提示",
    type: "inputSet",
    defaultValue: ''
  },
  {
    name: "backText",
    desc: "文字",
    type: "simpleFontSet",
    defaultValue: {
      ...defaultSimpleFontSetting,
      colorMode: 'complex'
    }
  },
  {
    name: "backTextAlign",
    desc: "对齐",
    type: "sliderSet",
    defaultValue: "center",
    extraConfig: {
      showToolTip: true,
      useType: "horizontalTextAlign",
      titleStyle: {
        width: "52px"
      }
    }
  },
  {
    name: "backTextMode",
    desc: "方向",
    type: "sliderSet",
    defaultValue: "horizontal-tb",
    extraConfig: {
      showToolTip: true,
      useType: "writingMode",
      titleStyle: {
        width: "52px"
      }
    }
  },
  {
    name: 'backTextLineHeight',
    desc: "行高",
    type: "numberSet",
    defaultValue: 16,
    unit: "px",
    extraConfig: {
      styleId: 2,
      suffix: 'px'
    }
  },
  {
    name: 'backTextLetterSpacing',
    desc: "字间距",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      styleId: 2,
      suffix: 'px'
    }
  },
  {
    name: "backTextHover",
    desc: "文字",
    type: "simpleFontSet",
    defaultValue: {
      ...defaultSimpleFontSetting,
      colorMode: 'complex'
    }
  },
  {
    name: "backSize",
    desc: "尺寸",
    type: "sizeSet",
    defaultValue: {
      ...defaultSizeSetting
    },
    extraConfig: {
      noFull: true
    }
  },
  {
    name: "backIcon",
    desc: "图标",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting
    }
  },
  {
    name: "backIconHover",
    desc: "图标",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting
    }
  },
  {
    name: "backTopBackground",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "backTopBackgroundHover",
    desc: "背景",
    type: "backgroundSet",
    defaultValue: defaultBackgroundSetting
  },
  {
    name: "showBackBorder",
    desc: "显示边框",
    type: "booleanSet",
    defaultValue: false
  },
  {
    name: "backBorder",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting
    }
  },
  {
    name: "backBorderHover",
    desc: "边框",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting
    }
  },
  {
    name: "enableBackPosition",
    desc: "开启定位",
    type: "booleanSet",
    defaultValue: true
  },
  {
    name: "backDis",
    desc: "偏移",
    type: "numberSet",
    defaultValue: 0
  },
  {
    name: "backRadius",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "backRadiusHover",
    desc: "圆角",
    type: "radiusSet",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "backOpacity",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "backOpacityHover",
    desc: "透明度",
    type: "numberSet",
    defaultValue: 100,
    formatter(val) {
      return val / 100
    }
  },
  {
    name: "backShadow",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "backShadowHover",
    desc: "阴影",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  }
]

export const menuSetting = [
  "enableBackToTop",
  {
    type: "status",
    enable(config) {
      return config.enableBackToTop
    },
    statusSettings: [
      {
        title: "默认",
        settings: [
          {
            type: "collapse",
            title: "文字",
            settings: [
              "showBackText",
              {
                type: "block",
                enable(config) {
                  return config.showBackText
                },
                settings: ["backText",  "backTextAlign", "backTextLineHeight", "backTextMode", "backTextLetterSpacing"]
              },
              "backInnerText", "backInnerTips"
            ]
          },
          {
            type: "collapse",
            title: "尺寸",
            settings: ["backSize"]
          },
          {
            type: "collapse",
            title: "图标",
            settings: ["backIcon"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["backTopBackground"]
          },
          {
            type: "collapse",
            title: "边框",
            settings: [
              "showBackBorder",
              {
                type: "basic",
                name: "backBorder",
                enable(config) {
                  return config.showBackBorder
                }
              },
              "backRadius"
            ]
          },
          {
            type: "collapse",
            title: "位置",
            settings: [
              "enableBackPosition",
              {
                type: "basic",
                name: "backDis",
                enable(config) {
                  return config.enableBackPosition
                }
              }
            ]
          },
          {
            type: "collapse",
            title: "更多",
            settings: ["backOpacity", "backShadow"]
          }
        ]
      },
      {
        title: "悬停",
        settings: [
          {
            type: "collapse",
            title: "文字",
            settings: ["backTextHover"]
          },
          {
            type: "collapse",
            title: "图标",
            settings: ["backIconHover"]
          },
          {
            type: "collapse",
            title: "背景",
            settings: ["backTopBackgroundHover"]
          },
          {
            type: "collapse",
            title: "边框",
            settings: ["backBorderHover", "backRadiusHover"]
          },
          {
            type: "collapse",
            title: "更多",
            settings: ["backOpacityHover", "backShadowHover"]
          }
        ]
      }
    ]
  }
]
